import { AuthService } from '../services';

export const isAuthenticatedInAuth0 = async () => {

    const isAuthenticated = await AuthService.isAuthenticated();

    return isAuthenticated;
};